import { render, staticRenderFns } from "./ParametrizacaoModalVideo.vue?vue&type=template&id=bae1a492&scoped=true"
import script from "./ParametrizacaoModalVideo.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoModalVideo.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoModalVideo.vue?vue&type=style&index=0&id=bae1a492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae1a492",
  null
  
)

export default component.exports